import Vue from 'vue'

import vueNumeralFilterInstaller from 'vue-numeral-filter'

Vue.use(vueNumeralFilterInstaller, { locale: 'en-gb' })
